export default __webpack_public_path__ + "static/media/sowmz-lamp-crop.19ec3be0.jpg";